import { Accordion, Box, Text, AccordionButton, Heading, AccordionPanel, AccordionIcon, AccordionItem } from "@chakra-ui/react";
import { List, ListItem, ListIcon, OrderedList, UnorderedList } from "@chakra-ui/react"
import React from "react";
import AppLayout from "../components/AppLayout";

export default function HackCriteria() {
    return (
        <AppLayout pageTitle={"Hack Judging Criteria | Hack+Policy Participant Portal"}>
            <Box
                p="3"
                bg="green.100"
                borderRadius="sm"
            >
                <Text fontSize="md">Projects will be evaluated based on the following set of criteria. Keep in mind that a project that focuses on only Hack or Policy will result in a poor score.</Text>
            </Box>
            <Box mt="10" fontSize="md">
                <Text borderBottom="black" borderBottomWidth="1.5px" fontSize="2xl" fontWeight="800">General (/25)</Text>
                <UnorderedList mt="8" fontSize="lg">
                    <ListItem><span style={{fontWeight: "bold"}}>Originality & Creativity (/5)</span> <br /> - Did the team do something novel, or take a fresh approach to the problem?</ListItem>
                    <br />
                    <ListItem><span style={{fontWeight: "bold"}}>Usefulness (/10)</span> <br /> - Is the project practical? <br /> - Does it solve the problem?</ListItem>
                    <br />
                    <ListItem><span style={{fontWeight: "bold"}}>Impact / General Outlook (/5)</span> <br /> - How much value does this project provide?</ListItem>
                    <br />
                    <ListItem><span style={{fontWeight: "bold"}}>Presentation (/5)</span> <br /> - Did the team work well together? <br /> - Is the project nicely presented?</ListItem>
                </UnorderedList>
            </Box>
            <Box mt="16" fontSize="md">
                <Text borderBottom="black" borderBottomWidth="1.5px" fontSize="2xl" fontWeight="800">Hack (/25)</Text>
                <UnorderedList mt="8" fontSize="lg">
                    <ListItem><span style={{fontWeight: "bold"}}>Technical Design & Implementation (/5)</span> <br /> - Did the team use innovative solutions to build the hack?</ListItem>
                    <br />
                    <ListItem><span style={{fontWeight: "bold"}}>Complexity (/10)</span> <br />- Was the technological aspect of the project hard to build?  <br /> - Did the team use clever techniques or implement complex components?</ListItem>
                    <br />
                    <ListItem><span style={{fontWeight: "bold"}}>UX / UI Design (/5)</span> <br /> - Is the user interface intuitive and easy to use? <br /> - Is it aesthetically pleasing?</ListItem>
                    <br />
                    <ListItem><span style={{fontWeight: "bold"}}>Completion & Functionality (/5)</span> <br /> - Is the hack usable? Does it work? <br /> - Does the hack achieve what the team wanted?</ListItem>
                </UnorderedList>
            </Box>
        </AppLayout>
    )
}